import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { AuthGuardData, createAuthGuard } from 'keycloak-angular';

// returns CanActivateFn to only allow users with requiredRole
export function requireRole(requiredRole: string): CanActivateFn {
  return createAuthGuard<CanActivateFn>(async (
      route: ActivatedRouteSnapshot,
      state: RouterStateSnapshot,
      authData: AuthGuardData
    ): Promise<boolean | UrlTree> => {
      const router = inject(Router);
      try {
        const { authenticated, grantedRoles, keycloak } = authData;

        if (!authenticated) {
          await keycloak.login({
            redirectUri: window.location.origin + state.url,
          });
          return false
        }

        const hasRealmRole = grantedRoles.realmRoles.includes(requiredRole);

        if (hasRealmRole) {
          return true;
        }

        return router.parseUrl('/no-access');

      } catch (e) {
        console.error(e);
        return router.parseUrl('https://pienso.com');
      }
    }
  );
}

// returns CanActivateFn to only allow authenticated users, regardless of role
export function requireAuthenticated(): CanActivateFn {
  return createAuthGuard<CanActivateFn>(async (
      route: ActivatedRouteSnapshot,
      state: RouterStateSnapshot,
      authData: AuthGuardData
    ): Promise<boolean | UrlTree> => {
      const { authenticated, keycloak } = authData;

      if (!authenticated) {
        await keycloak.login({
          redirectUri: window.location.origin + state.url,
        });
        return false;
      }

      return true;
    }
  );
}
